import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import {
  getRoles,
  createRole,
  updateRole,
  deleteRole,
} from "../../api/modules/roles/roles.api";
import type { CreateRoleDto, UpdateRoleDto } from "../../api/modules/roles/roles.types";

export const getRol = createAsyncThunk(
  "roles/getRoles",
  async (params: { search?: string } | undefined, { rejectWithValue, signal }) => {
    try {
      return await getRoles(params, signal);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addRol = createAsyncThunk(
  "roles/addRol",
  async (roles: CreateRoleDto, { rejectWithValue }) => {
    try {
      const response = await createRole(roles);
      toast.success("Rol creado", { autoClose: 3000 });
      return response;
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al crear el rol", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);

export const updateRol = createAsyncThunk(
  "roles/update",
  async (roles: UpdateRoleDto, { rejectWithValue }) => {
    try {
      const response = await updateRole(roles.id, roles);
      toast.success("El rol se actualizó correctamente", { autoClose: 3000 });
      return response;
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al actualizar el rol", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);

export const deleteRol = createAsyncThunk(
  "roles/deleteRol",
  async (id: string, { rejectWithValue }) => {
    try {
      await deleteRole(id);
      toast.success("El rol ha sido eliminado con éxito", { autoClose: 2000 });
      return { id };
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al eliminar el rol", { autoClose: 2000 });
      return rejectWithValue(error);
    }
  }
);
